import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useI18n, catName } from "@/lib/i18n";
import * as Icons from "lucide-react";

export default function Categories() {
  const { t, lang } = useI18n();
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 py-12">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#0F172A] mb-8">{t("nav.categories")}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {cats.map((c, i) => {
          const parts = (c.icon || "box").split("-").map((s) => s[0].toUpperCase() + s.slice(1)).join("");
          const Icon = Icons[parts] || Icons.Box;
          return (
            <motion.div key={c.slug} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
              <Link to={`/explore?category=${c.slug}`} data-testid={`cat-${c.slug}`}
                className="group relative overflow-hidden flex items-center gap-4 bg-white border border-[#E2E8F0] rounded-2xl p-6 hover:border-[#0EA5E9] hover:-translate-y-1 transition-[transform,border-color]">
                <div className="h-14 w-14 rounded-2xl bg-[#0F172A] text-white flex items-center justify-center group-hover:bg-[#0EA5E9] transition-colors">
                  <Icon className="h-6 w-6" />
                </div>
                <div>
                  <div className="font-display font-bold text-lg text-[#0F172A]">{catName(c, lang)}</div>
                  <div className="text-xs uppercase tracking-widest text-[#94A3B8]">{c.slug}</div>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
